/**
 * Estados y categorías del Mapa de Talento — UNA definición para backend,
 * frontend y shared. Auditoría 18/09/2026: las mismas uniones de literales
 * estaban escritas en talent-map-dynamo.ts (backend) y talentMapShared.ts
 * (frontend), y el z.enum del router repetía la lista a mano: agregar un estado
 * obligaba a tocar 3 archivos y nada avisaba si uno quedaba atrás.
 *
 * Los arrays `as const` son la fuente; los tipos se derivan. El router hace
 * `z.enum(RATED_TALENT_CATEGORIES)` y el front itera `RATED_TALENT_CATEGORIES`.
 */

export const TALENT_CATEGORIES = [
  'top_performer',
  'performance_solida',
  'cumple_con_oportunidades',
  'low_performance',
  'onboarding',
] as const;
export type TalentCategory = (typeof TALENT_CATEGORIES)[number];

/** Categorías que un líder puede poner, en el orden pedido por People (Euge 19/08/2026): de menor a mayor. */
export const RATED_TALENT_CATEGORIES = [
  'low_performance',
  'cumple_con_oportunidades',
  'performance_solida',
  'top_performer',
] as const satisfies readonly TalentCategory[];
export type RatedTalentCategory = (typeof RATED_TALENT_CATEGORIES)[number];
export function isRatedTalentCategory(c: string | null | undefined): c is RatedTalentCategory {
  return !!c && (RATED_TALENT_CATEGORIES as readonly string[]).includes(c);
}

export const TALENT_PROCESS_STATUSES = [
  'not_started',
  'draft',
  'pending_evidence',
  'confirmed',
  'hrbp_modified',
  // Categoría puesta por el cron de automatización (02/09): el líder todavía
  // no evaluó. Visible en el mapa, pero cuenta como "sin completar" en KPIs.
  'auto_assigned',
  'inactive',
] as const;
export type TalentProcessStatus = (typeof TALENT_PROCESS_STATUSES)[number];

/** Evaluación CERRADA: solo el botón Confirmar del líder o el override de People. El agente nunca (incidente 07/09). */
export const CLOSED_TALENT_STATUSES = ['confirmed', 'hrbp_modified'] as const satisfies readonly TalentProcessStatus[];
export function isClosedTalentStatus(s: string | null | undefined): boolean {
  return !!s && (CLOSED_TALENT_STATUSES as readonly string[]).includes(s);
}

// 'license' (18/09, copiado de D-Talk): fuera del ciclo, se marca a mano.
export const TALENT_ELIGIBILITY_STATUSES = ['eligible', 'onboarding', 'inactive', 'license'] as const;
export type TalentEligibilityStatus = (typeof TALENT_ELIGIBILITY_STATUSES)[number];

/** Motivo de un cambio automático de categoría (aclaraciones People 01/09). */
export type SystemChangeReason = 'onboarding_completed' | 'promotion_level_change';

/**
 * Tope de caracteres de un mensaje del chat de evaluación (zod del procedure y
 * `maxLength` del cuadro de texto). Mismo motivo que `DTALK_MAX_MESSAGE_CHARS`
 * (shared/types/dtalk.ts): pasarse del tope devolvía un 400 que en el chat se
 * veía como "no se pudo enviar" con un "Reintentar" que iba a fallar siempre.
 * 6000 desde el 02/10/2026, igual que D-Talk y por el mismo motivo (el líder
 * que escribe evidencia de una persona también se pasaba de 3000).
 */
export const TALENT_MAP_MAX_MESSAGE_CHARS = 6000;
